<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">회의실 · 법인차 관리</div>
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: kind === 'room' }" @click="changeKind('room')">
					회의실
				</button>
				<button type="button" class="btn tab" v-bind:class="{ active: kind === 'car' }" @click="changeKind('car')">
					법인차
				</button>
			</div>
			<div class="tab-con">
				<div class="txt-c--grey mb-1">
					※ 여기 등록된 항목이 예약 화면의 {{ kindLabel }} 목록이 됩니다.
					사용 해제하면 새 예약은 막히지만 기존 예약 기록은 그대로 남습니다.
				</div>
				<div class="table-wrap">
					<table class="table">
						<colgroup>
							<col width="12%" /><col width="8%" /><col width="30%" /><col width="24%" />
							<col width="10%" /><col width="16%" />
						</colgroup>
						<tr>
							<th>순서</th>
							<th>번호</th>
							<th>{{ kindLabel }} 이름</th>
							<th>{{ kind === 'car' ? '차량번호' : '비고' }}</th>
							<th>사용</th>
							<th>관리</th>
						</tr>
						<tr v-for="(r, idx) in itemList" :key="'br_' + r.booking_resource_uid">
							<td>
								<button
									type="button"
									class="btn sort"
									v-if="idx != 0"
									@click="btnOrder(itemList[idx - 1].booking_resource_uid, r.booking_resource_uid)"
								>
									<b-icon-arrow-up />
								</button>
								<button
									type="button"
									class="btn sort"
									v-if="idx + 1 != itemList.length"
									@click="btnOrder(r.booking_resource_uid, itemList[idx + 1].booking_resource_uid)"
								>
									<b-icon-arrow-down />
								</button>
							</td>
							<td>{{ idx + 1 }}</td>
							<td><input type="text" class="form-control sm" v-model="r.name" maxlength="50" /></td>
							<td><input type="text" class="form-control sm" v-model="r.res_no" maxlength="50" /></td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="r.use_flag" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnUpdate(r)">저장</button>
							</td>
						</tr>
						<tr>
							<td colspan="2">추가</td>
							<td>
								<input
									type="text"
									class="form-control sm"
									v-model="addInfo.name"
									:placeholder="kind === 'car' ? '차량명' : '회의실 이름'"
								/>
							</td>
							<td>
								<input
									type="text"
									class="form-control sm"
									v-model="addInfo.res_no"
									:placeholder="kind === 'car' ? '차량번호' : '비고'"
								/>
							</td>
							<td colspan="2">
								<button type="button" class="btn btn-xsm btn-primary" @click="btnAdd">추가</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SystemAdmin16',
	data() {
		return {
			kind: 'room',
			itemList: [],
			addInfo: { name: '', res_no: '' },
		};
	},
	computed: {
		kindLabel() {
			return this.kind === 'car' ? '법인차' : '회의실';
		},
	},
	created() {
		this.getItemList();
	},
	methods: {
		changeKind(k) {
			this.kind = k;
			this.addInfo = { name: '', res_no: '' };
			this.getItemList();
		},
		getItemList() {
			// all=Y — 관리 화면은 사용 해제된 자원도 보여야 다시 켤 수 있다.
			this.$apiGET(`/admin/api/booking/resource?kind=${this.kind}&all=Y`).then(re => {
				this.itemList = Array.isArray(re) ? re : [];
			});
		},
		btnAdd() {
			if (!this.addInfo.name || !this.addInfo.name.trim()) {
				alert(`${this.kindLabel} 이름을 입력하세요.`);
				return;
			}
			this.$apiPOST('/admin/api/booking/resource/add', {
				res_kind: this.kind,
				name: this.addInfo.name.trim(),
				res_no: this.addInfo.res_no,
			}).then(re => {
				if (re === false || !re || re.ok !== true) return;
				this.addInfo = { name: '', res_no: '' };
				this.getItemList();
			});
		},
		btnUpdate(r) {
			if (!r.name || !r.name.trim()) {
				alert(`${this.kindLabel} 이름을 입력하세요.`);
				return;
			}
			this.$apiPOST('/admin/api/booking/resource/update', {
				resUid: r.booking_resource_uid,
				name: r.name.trim(),
				res_no: r.res_no,
				use_flag: r.use_flag,
			}).then(re => {
				if (re !== true) return;
				this.getItemList();
			});
		},
		btnOrder(u1, u2) {
			this.$apiPOST('/admin/api/booking/resource/order', { uid_1: u1, uid_2: u2 }).then(re => {
				if (re !== true) return;
				this.getItemList();
			});
		},
	},
};
</script>

<style></style>
